import { Injectable } from "@angular/core";
import { ApiCallUrlService } from "@modules/common/services/api-call-url.service";

@Injectable({
    providedIn: 'root'
})
export class LoginMainImageUrlService {
    constructor(private _apiCallUrlService: ApiCallUrlService) { }

    public getUrl(logoVersion: string): string {
        return this._apiCallUrlService.getUrl('/PortalConfig/GetLoginMainImage/GetLoginMainImage?v=' + logoVersion);
    }
}
